import { render, staticRenderFns } from "./BuildingNotes.vue?vue&type=template&id=3d5af68e&scoped=true&"
import script from "./BuildingNotes.vue?vue&type=script&lang=js&"
export * from "./BuildingNotes.vue?vue&type=script&lang=js&"
import style0 from "./BuildingNotes.vue?vue&type=style&index=0&id=3d5af68e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5af68e",
  null
  
)

export default component.exports